<script>
import axios from "axios";
import moment from "moment/moment";
import EditCallHistoryModal from "@/components/modal/EditCallHistoryModal.vue";

export default {
  name: "CallTimeline",
  components: {EditCallHistoryModal},
  props: ['callId'],
  expose: ['getTimeline'],
  data() {
    return {
      events: [],
      selectedEvent: null
    }
  },
  methods: {
    getTimeline() {
      axios.get('call/timeline?call_id=' + this.callId)
          .then((response) => {
            this.events = response.data
          });
    },
    openEditModal(event) {
      this.selectedEvent = event;
      this.$refs.editHistoryModal.show();
    },
    onHistoryUpdated() {
      this.getTimeline();
    }
  },
  mounted() {
    this.getTimeline();
  },
  computed: {
    moment() {
      return moment
    }
  },
}
</script>

<template>
 <div class="card">
   <div class="card-header">
     <h5 class="mb-0">
       <i class="bi bi-clock-history me-2"></i>Timeline
     </h5>
   </div>
   <div class="card-body">
     <div class="list-group">
       <div class="list-group-item text-start d-flex justify-content-between align-items-start" v-for="event in events" v-bind:key="event.id">
         <div class="flex-grow-1">
           <div class="fw-bold text-muted small mb-1">
             {{moment(event.created_at).format('YYYY-MM-DD HH:mm')}}
           </div>
           <div>{{event.message}}</div>
         </div>
         <button
           @click="openEditModal(event)"
           class="btn btn-sm btn-outline-primary ms-2"
           title="Edit event">
           <i class="bi bi-pencil"></i>
         </button>
       </div>
     </div>
     <div v-if="events.length === 0" class="text-center text-muted py-4">
       <i class="bi bi-inbox"></i> No timeline events yet
     </div>
   </div>
   <EditCallHistoryModal
     ref="editHistoryModal"
     :history-event="selectedEvent"
     @history-updated="onHistoryUpdated"
   />
 </div>
</template>

<style scoped>

</style>